<div *ngIf="isUpdateAvailable$ | async" class="app-version-banner" role="status" aria-live="polite">
  <span i18n="@@common.appVersionPrompt.message">FBO has been updated. Save your work, then reload to continue.</span>
  <button class="btn btn-sm btn-default app-version-banner__btn" (click)="reload()" i18n="@@common.appVersionPrompt.confirm">Reload now</button>
</div>
